
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.667 6v3.107l-2.334 2.34v1.22h-.666v-1.22L5.333 9.1V6h5.334zm0-4H9.333v2.667H6.667V2H5.333v2.667h-.006A1.324 1.324 0 004 5.987v3.68L6.333 12v2h3.334v-2L12 9.66V6c0-.733-.6-1.333-1.333-1.333V2z","fill":"currentColor"}})])
          )
        }
      }
    